export * from './FoldersIcon';
export * from './FoldersIcon16Light';
export * from './FoldersIcon16Regular';
export * from './FoldersIcon16Solid';
export * from './FoldersIcon20Light';
export * from './FoldersIcon20Regular';
export * from './FoldersIcon20Solid';
export * from './FoldersIcon24Regular';
export * from './FoldersIcon24Solid';
export * from './FoldersIcon32Regular';
export * from './FoldersIcon64Regular';
